import { discardCachedVideoElement } from '../../ensureCachedVideoElement';
import { Wrapper } from './Wrapper';
export class VideoElementWrapper extends Wrapper {
    constructor(type, video, videoEl) {
        super(type, video);
        this.videoEl = videoEl;
        // Transparent gif poster is needed for some android webviews which
        // display enlarged play icon instead.
        this.videoEl.poster =
            'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7';
    }
    get duration() {
        return this.videoEl.duration;
    }
    get className() {
        return this.videoEl.className;
    }
    set className(value) {
        this.videoEl.className = value;
    }
    get crossOrigin() {
        return this.videoEl.crossOrigin;
    }
    set crossOrigin(value) {
        this.videoEl.crossOrigin = value;
    }
    get currentTime() {
        return this.videoEl.currentTime;
    }
    set currentTime(value) {
        this.videoEl.currentTime = value;
    }
    get loop() {
        return this.videoEl.loop;
    }
    set loop(value) {
        this.videoEl.loop = value;
    }
    get muted() {
        return this.videoEl.muted;
    }
    set muted(value) {
        this.videoEl.muted = value;
    }
    get volume() {
        return this.videoEl.volume;
    }
    set volume(value) {
        this.videoEl.volume = value;
    }
    get playsInline() {
        return this.videoEl.playsInline;
    }
    set playsInline(value) {
        this.videoEl.playsInline = value;
    }
    get poster() {
        return this.videoEl.poster;
    }
    set poster(value) {
        this.videoEl.poster = value;
    }
    get preload() {
        return this.videoEl.preload;
    }
    set preload(value) {
        this.videoEl.preload = value;
    }
    set tabIndex(value) {
        this.videoEl.tabIndex = value;
    }
    get seeking() {
        return this.videoEl.seeking;
    }
    get autoplay() {
        return this.videoEl.autoplay;
    }
    set autoplay(value) {
        this.videoEl.autoplay = value;
    }
    get ended() {
        return this.videoEl.ended;
    }
    get readyState() {
        return this.videoEl.readyState;
    }
    get src() {
        return this.videoEl.src;
    }
    set src(value) {
        this.videoEl.src = value;
    }
    get paused() {
        return this.videoEl.paused;
    }
    get width() {
        return this.videoEl.width;
    }
    get height() {
        return this.videoEl.height;
    }
    get textTracks() {
        return this.videoEl.textTracks;
    }
    set onCanPlay(value) {
        this.videoEl.oncanplay = value;
    }
    set onClick(value) {
        this.videoEl.onclick = value;
    }
    set onLoadStart(value) {
        this.videoEl.oncanplay = value;
    }
    load() {
        this.videoEl.load();
    }
    play() {
        return this.videoEl.play();
    }
    pause() {
        return this.videoEl.pause();
    }
    dispatchEvent(event) {
        return this.videoEl.dispatchEvent(event);
    }
    addEventListener(type, listener, options) {
        this.videoEl.addEventListener(type, listener, options);
    }
    removeEventListener(type, listener, options) {
        this.videoEl.removeEventListener(type, listener, options);
    }
    querySelectorAll(selectors) {
        return this.videoEl.querySelectorAll(selectors);
    }
    appendChild(child) {
        return this.videoEl.appendChild(child);
    }
    getContainer() {
        return this.videoEl;
    }
    reset(cacheKey, video) {
        if (!video) {
            discardCachedVideoElement(cacheKey);
        }
    }
}
